import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-quickLayout",
  "use": "icon-quickLayout-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-quickLayout\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M4,3.2H20a1,1,0,0,1,1,1v16a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V4.2A1,1,0,0,1,4,3.2Zm4,2H5v3H8Zm0,14v-3H5v3Zm0-9H5v4H8Zm8-5v3h3v-3Zm-2,0H10v3h4Zm2,14h3v-3H16Zm-2,0v-3H10v3Zm2-9v4h3v-4Zm-2,0H10v4h4Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol